import { Fragment, useState, useEffect, } from "react";
import { useTranslation } from 'react-i18next';

import MergerDogImage1 from "../../images/imageMerger/merger-dog-1-h100.jpeg";
import MergerDogImage2 from "../../images/imageMerger/merger-dog-2-h100.jpeg";
import MergerDogMerged from "../../images/imageMerger/merger-dog-merge-h100.jpeg";
import MergerFaceImage1 from "../../images/imageMerger/merger-body-h50.png";
import MergerFaceImage2 from "../../images/imageMerger/merger-eye-mouth-h50.png";
import MergerFaceMerged from "../../images/imageMerger/merger-face-merged-h50.png";
import MergerFaceMerged2 from "../../images/imageMerger/merger-face-merged2-h50.png";
import MergerExImage1 from "../../images/imageMerger/merger-convert-1-h50.jpeg";
import MergerExImage2 from "../../images/imageMerger/merger-convert-2-h50.jpeg";
import MergerExMerged from "../../images/imageMerger/merger-convert-h100.jpeg";

import "./ImageMerger.css";

export default function MergerInfo(props) {
  const {} = props;

  const [t] = useTranslation('translation');

  return (
    <Fragment>
      <div>
        <div className="combinerInfoTitle">
            Image Merger
        </div>
        <br />

        <p>
          Image Merger 
          {' '}
          {t('imageMerger01', 'is a tool to create a image by merging two images.')}
          <br/>
          {t('imageMerger02', 'This tool is useful when user has multiple images and want to display these images in one image.')}
          {' '}
        </p>
        <br />

        <p>
          <div>
            At Image Editor, 
            {' '}
            {t('combinerInfo05', 'it is possible to crop images for desired image aspect ratio.')}
          </div>
          <div>
            At Image Resizer,
            {' '}
            {t('imageMerger03', 'user can resize images.')}
          </div>
        </p>
        <br />
      </div>
      <br/>

      <div>
        <div>
            <strong>
              {t('imageMerger04', 'example images')}
            </strong>
        </div>
        <br/>
        <div className="combinerExampleImages">
          <span>
            <div>
              <img 
                style={{ height: "100px" }} 
                src={MergerDogImage1} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 1</div>
          </span>
          <span>
            <div>
              <img style={{ 
                height: "100px" }} 
                src={MergerDogImage2} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 2</div>
          </span>
          <span>
            <div>
              <img 
                style={{ height: "100px" }} 
                src={MergerDogMerged} 
              />
            </div>
            <div>
              {t('imageMerger05', 'merged image')}
            </div>
          </span>
        </div>
        <br/>

        <div className="combinerExampleImages">
          <span>
            <div>
              <img 
                style={{ height: "50px" }} 
                src={MergerExImage1} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 1</div>
          </span>
          <span>
            <div>
              <img style={{ 
                height: "50px" }} 
                src={MergerExImage2} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 2</div>
          </span>
          <span>
            <div>
              <img 
                style={{ height: "100px" }} 
                src={MergerExMerged} 
              />
            </div>
            <div>
              {t('imageMerger05', 'merged image')}
            </div>
          </span>
        </div>
        <br/>

        <div>
          {t('imageMerger06', 'Various images are created by setting position of images.')}
        </div>
        <br/>

        <div className="combinerExampleImages">
          <span>
            <div>
              <img 
                style={{ height: "80px" , 
                  // border: "1px, dashed, gray"
                }} 
                src={MergerFaceImage1} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 1</div>
          </span>
          <span>
            <div>
              <img style={{ 
                height: "80px", 
                // border: "1px, dashed, gray" 
              }} 
                src={MergerFaceImage2} 
              />
            </div>
            <div>{t('combiner03', 'Image')} 2</div>
          </span>
          <span>
            <div>
              <img 
                style={{ height: "80px", 
                  // border: "1px, dashed, gray" 
                }} 
                src={MergerFaceMerged} 
              />
            </div>
            <div>
              {t('imageMerger05', 'merged image')}
            </div>
          </span>
          <span>
            <div>
              <img 
                style={{ height: "80px", 
                  // border: "1px, dashed, gray" 
                }} 
                src={MergerFaceMerged2} 
              />
            </div>
            <div>
              {t('imageMerger05', 'merged image')}
            </div>
          </span>
        </div>
        <br/>

      
      </div>
    </Fragment>
  );
}
